var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('forgot-password-link',{attrs:{"forgotPasswordRoute":"/forgot-password"}})],1),_vm._v(" "),_c('div',{staticClass:"p-auth__padlock-icon mb-4"})])}
var staticRenderFns = []

export { render, staticRenderFns }